import MuiTimePicker from "@mui/lab/TimePicker";
import TextField from "@mui/material/TextField";

const TimePicker = (props) => {
  const { label, time, format, onChange } = props;

  const value = new Date();
  const [hours, minutes] = (time ? time : "00:00").split(":");
  value.setHours(parseInt(hours));
  value.setMinutes(parseInt(minutes));

  return (
    <MuiTimePicker
      label={label}
      value={value}
      inputFormat={format}
      onChange={(date) => onChange(date)}
      disableMaskedInput={true}
      renderInput={(inputProps) => (
        <TextField {...inputProps} variant="standard" />
      )}
    />
  );
};

export default TimePicker;
